import { render, staticRenderFns } from "./RatingInfo.vue?vue&type=template&id=ae366fb8&"
import script from "./RatingInfo.vue?vue&type=script&lang=js&"
export * from "./RatingInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports